export const calculateMinMaxRelativePercentage = (domain: number[]) => {
  if (!Array.isArray(domain) || domain.length === 0) {
    console.error('Invalid input. Please provide a non-empty array of numbers.');
    return;
  }

  let max = domain[0] ?? 0;
  let min = 0;

  for (let i = 1; i < domain.length; i++) {
    const element = domain[i] ?? 0;
    if (element > max) {
      max = element;
    }

    if (element < min) {
      min = element;
    }
  }

  const result = domain.map((value) => ({
    value,

    relativePercentage: ((value - min) / (max - min)) * 100,
  }));

  return {
    max,
    min,
    relativePercentage: result,
  };
};

export const tableCells = ['File Name', 'Records', 'Errors', 'Matching ID', 'Missing ID', 'OK', 'KO', 'Upload Date'];

export const featureImportanceTooltip =
  'This chart offers an overview of the contribution of each feature against the assigned class. The  higher the feature name in the chart, the more important the feature is to predict the provided class (either OK or KO). The figure is meant to offer a qualitative view of the feature importance, enabling comparisons among different features.';

export const scatterPlotTooltip =
  'This chart visualizes the distribution of the provided dataset across Trustfull scores. In particular, KO and OK samples are distinguished by different colors, enabling easy identification of the predominant positions of each class within the score range.';

export const okDonutTooltip =
  "This donut chart offers a comprehensive visual representation of the distribution of Trustfull score cluster,  focusing on instances marked as 'OK.' Each segment of the donut corresponds to a distinct score cluster, providing a clear overview of how 'OK. data is distributed across clusters.";
export const koDonutTooltip =
  "This donut chart offers a comprehensive visual representation of the distribution of Trustfull score cluster,  focusing on instances marked as 'KO.' Each segment of the donut corresponds to a distinct score cluster, providing a clear overview of how 'KO. data is distributed across clusters.";

export const getScatterCluster = (activeTab: number) => {
  switch (activeTab) {
    case 0:
      return 'full';
    case 1:
      return 'poor';
    case 2:
      return 'bad';
    case 3:
      return 'moderate';
    case 4:
      return 'good';
    case 5:
      return 'high';
    default:
      return 'full';
  }
};

export const replaceKeys = (originalObj: any): any => {
  if (originalObj) {
    const replacedObj = {
      very_low: originalObj.poor || 0,
      low: originalObj.bad || 0,
      review: originalObj.moderate || 0,
      high: originalObj.good || 0,
      very_high: originalObj.high || 0,
    };

    return replacedObj;
  }
};

export const createWaffleChartDataSingle = (value: number | undefined) => {
  if (value === undefined) return [];
  return [...Array(value)].map((_, i) => {
    const index = i + 1;
    const tens = Math.floor(index / 10);
    const units = index - tens * 10 === 0 ? 10 : index - tens * 10;
    return { x: units, y: tens + (index % 10 === 0 ? 0 : 1) };
  });
};

export const getActiveProduct = (e: string) => {
  if (e.includes('email')) return 'Email';
  if (e.includes('phone')) return 'Phone';
  if (e.includes('cross')) return 'Multiple Products';
  if (e.includes('match')) return 'Multiple Products';
  if (e.includes('ip')) return 'IP Address';
  if (e.includes('device')) return 'Device';
  if (e.includes('name')) return 'Name';
  if (e.includes('browser')) return 'Browser';
  return '';
};
